"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AgreementItem_1 = require("./AgreementItem");
var styles = __importStar(require("./AgreementList.module.css"));
var AggrementList = (function (_super) {
    __extends(AggrementList, _super);
    function AggrementList(props) {
        return _super.call(this, props) || this;
    }
    AggrementList.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors, identifier = _a.identifier, conditions = _a.agreement.conditions;
        return (react_1.default.createElement("ol", { className: styles.agreementContainer }, conditions.map(function (_a, idx) {
            var subtitle = _a.subtitle, description = _a.description;
            return (react_1.default.createElement(AgreementItem_1.AgreementItem, { key: idx, title: subtitle, description: description, json_data: json_data, identifier: identifier + "_" + (idx + 1), onChange: onChange, errors: errors }));
        })));
    };
    return AggrementList;
}(react_1.Component));
exports.AggrementList = AggrementList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWdyZWVtZW50TGlzdC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2ludGVsbGl0ZWMvRW5yb2xsZW1udFBhY2tldEluZm8vcGFydHMvU2VjdGlvbjUvQWdyZWVtZW50L0FncmVlbWVudExpc3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBc0M7QUFFdEMsaURBQTZDO0FBQzdDLGlFQUFvRDtBQVVwRDtJQUFtQyxpQ0FBb0I7SUFDbkQsdUJBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBRUQsOEJBQU0sR0FBTjtRQUNVLElBQUEsZUFNUSxFQUxWLHdCQUFTLEVBQ1Qsc0JBQVEsRUFDUixrQkFBTSxFQUNOLDBCQUFVLEVBQ0Usb0NBQ0YsQ0FBQTtRQUVkLE9BQU8sQ0FDSCxzQ0FBSSxTQUFTLEVBQUUsTUFBTSxDQUFDLGtCQUFrQixJQUNuQyxVQUFVLENBQUMsR0FBRyxDQUFDLFVBQUMsRUFBdUIsRUFBRSxHQUFHO2dCQUEzQixzQkFBUSxFQUFFLDRCQUFXO1lBQVcsT0FBQSxDQUM5Qyw4QkFBQyw2QkFBYSxJQUNWLEdBQUcsRUFBRSxHQUFHLEVBQ1IsS0FBSyxFQUFFLFFBQVEsRUFDZixXQUFXLEVBQUUsV0FBVyxFQUN4QixTQUFTLEVBQUUsU0FBUyxFQUNwQixVQUFVLEVBQUssVUFBVSxVQUFJLEdBQUcsR0FBRyxDQUFDLENBQUUsRUFDdEMsUUFBUSxFQUFFLFFBQVEsRUFDbEIsTUFBTSxFQUFFLE1BQU0sR0FDaEIsQ0FDTDtRQVZpRCxDQVVqRCxDQUFDLENBQ0QsQ0FDUixDQUFBO0lBQ0wsQ0FBQztJQUNMLG9CQUFDO0FBQUQsQ0FBQyxBQTlCRCxDQUFtQyxpQkFBUyxHQThCM0M7QUE5Qlksc0NBQWEifQ==